<template>
	<ext-dialog
		v-model="value"
		:title="$t('edit_description')"
		:primaryButtonText="$t('save_changes')"
		@primaryButtonAction="save"
		@closed="close"
	>
		<template #body>
			<v-form ref="form" v-model="valid">
				<localized-text-field
					v-model="localDesc"
					:defaultLanguage="companyDefaultLanguage"
					:options="companyLanguageOptions"
					:rules="[]"
					:label="$t('description')"
				/>
			</v-form>
		</template>
	</ext-dialog>
</template>

<script>
import ExtDialog from "../../../partials/dialogs/ExtDialog.vue";
import LocalizedTextField from "../../../controls/LocalizedTextField.vue";
import uiMixin from '../../../../store/interfaces/ui.mixin';
import { mapGetters } from "vuex";

export default {
	mixins: [uiMixin],
	components: { ExtDialog, LocalizedTextField },
	props: {
		value: Boolean,
		descriptionData: Object,
	},
	data() {
		return {
			localDesc: {},
			valid: true,
		};
	},
	computed: {
		...mapGetters(["companyDefaultLanguage", "companyLanguageOptions"]),
	},
	watch: {
		value(val) {
			if (val) {
				this.localDesc = { ...this.descriptionData };
				if (!this.localDesc[this.companyDefaultLanguage]) {
					this.localDesc[this.companyDefaultLanguage] = "";
				}
			} else if (this.$refs.form) {
				this.$refs.form.reset();
			}
		},
	},
	methods: {
		save() {
			if (!this.$refs.form.validate()) {
				return;
			}
			if (!this.localDesc[this.companyDefaultLanguage]) {
				this.showAlertDialog({
					message: this.$t("$validation.required_for_default_language", {
						item: this.$t("description"),
					}),
				});
				return;
			}
			this.$emit("save", this.localDesc);
			this.$emit("input", false);
		},
		close() {
			this.$emit("input", false);
		},
	},
};
</script>
